import request from '@/utils/request'

export function delAudio(data) {
    return request({
        url: '/api/member-score/delete',
        method: 'post',
        data
    })
}

export function upLoadWAV(obj) {
    return request({
        url: '/api/member-score/file',
        method: 'post',
        data: obj,
        headers: {
            'Content-Type':'application/x-www-form-urlencoded'
        }
        
    })
}

export function list(obj) {
    return request({
        url: '/api/projects/list',
        method: 'get',
        params: obj
    })
}

export function getProject(projectId) {
    return request({
        url: '/api/projects/project',
        method: 'get',
        params: {projectId: projectId}
    })
}

export function addProjectApi(data) {
    return request({
        url: '/api/projects/add',
        method: 'post',
        data
    })
}

export function memberList(projectId) {
    return request({
        url: '/api/project-member/list',
        method: 'get',
        params: { projectId: projectId }
    })
}

export function addMember(data) {
    return request({
        url: '/api/projects/add-member',
        method: 'post',
        data
    })
}

export function delMember(projectid, memberId) {
    var data = {
        memberId: memberId,
        projectId: projectid
    }
    return request({
        url: '/api/project-member/delete',
        method: 'post',
        data
    })
}

export function submitScore(data) {
    return request({
        url: '/api/member-score/submit',
        method: 'post',
        data
    })
}
